import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
const DropdownItem = t0 => {
  const $ = _c(8);
  const {
    item,
    index
  } = t0;
  const t1 = index !== 0;
  let t2;
  if ($[0] !== t1) {
    t2 = classNames("px-2 py-4 text-xs", {
      "border-t border-gray-light6": t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = item?.text;
  let t4;
  if ($[2] !== item?.subtext) {
    t4 = item?.subtext && <div className="text-[10px]">{item?.subtext?.length > 22 ? `${item?.subtext?.substr(0, 22)}...` : item?.subtext}</div>;
    $[2] = item?.subtext;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default DropdownItem;